module.exports = __webpack_public_path__ + "img/esperando.afef3f35.gif";